import { cn } from '@/utils';
import styles from './Loading.module.scss';
type LoadingProps = {
  covered?: boolean;
};
export default function Loading(props: LoadingProps) {
  return <>
      <div className={styles.loading_container} style={{
      width: '100%',
      height: props.covered ? '100%' : '100vh',
      position: props.covered ? 'absolute' : 'inherit'
    }}>
        <LoadingImage data-sentry-element="LoadingImage" data-sentry-source-file="Loading.tsx" />
      </div>
    </>;
}
export const LoadingImage = ({
  className
}: {
  className?: string;
}) => {
  return <img className={cn(styles.loading_spinner_img, 'size-[48px]', className)} src="/assets/loading.png" alt="loading" data-sentry-component="LoadingImage" data-sentry-source-file="Loading.tsx" />;
};